import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ContractorAuthService from '../../services/ContractorAuthService';

const ContractorLogin = ({ onLogin }) => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    console.log('🚀 Form submitted with data:', formData);

    try {
      console.log('📡 Calling ContractorAuthService.login...');
      const response = await ContractorAuthService.login(formData);
      
      const success = response.success || response.Success;
      console.log('🔍 Login response:', response);
      console.log('🔍 Success:', success);
      
      if (success) {
        const token = response.token || response.Token;
        const user = response.user || response.User;
        console.log('🔍 Token:', token);
        console.log('🔍 User:', user);
        
        localStorage.setItem('contractorToken', token);
        localStorage.setItem('contractorUser', JSON.stringify(user));
        
        console.log('🔍 Calling onLogin with user:', user);
        onLogin(user);
        
        // Force navigation to contractor dashboard
        console.log('🚀 Navigating to /contractor/dashboard');
        navigate('/contractor/dashboard');
      } else {
        const message = response.message || response.Message;
        setError(message);
      }
    } catch (error) {
      console.error('💥 Contractor login error:', error);
      console.error('💥 Error message:', error.message);
      console.error('💥 Error stack:', error.stack);
      setError('Login failed. Please try again.');
    } finally {
      console.log('🏁 Login process finished, setting loading to false');
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-green-100 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <div className="mx-auto h-16 w-auto flex items-center justify-center">
            <div className="flex items-center space-x-3">
              <div className="relative">
                <div className="text-4xl text-blue-600">🏠</div>
                <div className="absolute -top-1 -right-1 text-lg text-green-500">🛡️</div>
              </div>
              <div className="text-3xl font-bold bg-gradient-to-r from-blue-600 to-green-600 bg-clip-text text-transparent">
                ACVentures
              </div>
            </div>
            <div className="mt-1 text-xs text-gray-500 text-center">
              Contractor Portal
            </div>
          </div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Contractor Sign In
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Access your work orders and payment information
          </p>
        </div>
        
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          {error && (
            <div className="bg-red-50 border border-red-200 rounded-md p-4">
              <div className="text-sm text-red-600">{error}</div>
            </div>
          )}
          
          <div className="space-y-4">
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                Email Address
              </label>
              <input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                required
                value={formData.email}
                onChange={handleChange}
                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                placeholder="Enter your email"
              />
            </div>
            
            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                Password
              </label>
              <input
                id="password"
                name="password"
                type="password"
                autoComplete="current-password"
                required
                value={formData.password}
                onChange={handleChange}
                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                placeholder="Enter your password"
              />
            </div>
          </div>

          <div>
            <button
              type="submit"
              disabled={loading}
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? 'Signing in...' : 'Sign in'}
            </button>
          </div>

          <div className="text-center">
            <p className="text-sm text-gray-600">
              Need access? Contact ACVentures for an invitation.
            </p>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ContractorLogin;

